import API from "../api";

export const getPegawai = () => API.get("/pegawai");
export const addPegawai = (data) => API.post("/pegawai", data);
export const updatePegawai = (nip, data) => API.put(`/pegawai/${nip}`, data);
export const deletePegawai = (nip) => API.delete(`/pegawai/${nip}`);
